import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useTheme } from '../context/ThemeContext';

export default function CartToast() {
  const { state } = useCart();
  const { isDark } = useTheme();
  const [visible, setVisible] = useState(false);
  const [productName, setProductName] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    if (!state.lastAdded) return;
    setProductName(state.lastAdded.product.name);
    setVisible(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), 2500);
    return () => clearTimeout(timerRef.current);
  }, [state.lastAdded]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          className={`fixed top-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-5 py-3 rounded-xl shadow-lg ${
            isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
          }`}
        >
          <div className="w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center flex-shrink-0">
            <Check size={16} className="text-white" />
          </div>
          <div className="text-sm">
            <span className="font-semibold">{productName}</span>{' '}
            <span className={isDark ? 'text-gray-400' : 'text-gray-500'}>added to cart</span>
          </div>
          <ShoppingBag size={16} className="text-emerald-600 flex-shrink-0" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
